export const getConfigurations = (variants = []) => {
    return (variants || []).map((v, i) => {
        const { ctaViewDetailsLink, linkUrl, overViewLabels, overviewAttributes: oa, ...rest } = v;
        const overviewAttributes = { ...oa };
        return {
            value: ctaViewDetailsLink || linkUrl,
            overviewAttributes,
            ...rest,
        };
    });
};

export const getSelectedVariant = (variants, value) => {
    return (
        variants.find(c => {
            const { value: cValue } = c;
            return cValue === value;
        }) || variants[0]
    );
};
